import { Center, Container, Stack, Text, Title } from '@mantine/core';
import { useRouteError } from 'react-router-dom';

import { useLogger } from '@hooks/useLogger';

export const RouteErrorBoundary = () => {
  const error = useRouteError() as Error;
  const { logError } = useLogger();

  logError(error);

  return (
    <Center mt={200}>
      <Container size="sm">
        <Stack align="center" gap="md">
          <Title order={2} c="red">
            Something went wrong
          </Title>
          <Text c="dimmed" ta="center">
            An unexpected error occurred in the application. Try refreshing the page or contact support if the issue persists.
          </Text>
        </Stack>
      </Container>
    </Center>
  );
};
